import { render, staticRenderFns } from "./SkeletonUserComment.vue?vue&type=template&id=7c39d148&"
import script from "./SkeletonUserComment.vue?vue&type=script&lang=js&"
export * from "./SkeletonUserComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports